import { Box } from "@mui/material";
import { CircleX } from "lucide-react";

const CloseModalButton = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <CircleX size={24} color="#657482" strokeWidth={1.5} />
    </Box>
  );
};

export default CloseModalButton;
